import { AUTH_PROVIDER_MAX_LEN, AUTH_PROVIDER_MIN_LEN } from 'bundles/page/common/constants';

export const sanitizeAuthProvider = (authProviderString: string) => {
  const sanitizedString = encodeURIComponent(authProviderString);
  if (sanitizedString.length > AUTH_PROVIDER_MIN_LEN && sanitizedString.length < AUTH_PROVIDER_MAX_LEN) {
    return sanitizedString;
  }
  return undefined;
};
